/**
 * mediaLightbox — SEP 8 2026 (web parity with the mobile MediaViewerModal).
 * Click any post photo/video and it opens FULLSCREEN. Framework-free (plain
 * DOM overlay appended to <body>) so any component — App.js feed, profile
 * posts, ProfilePage — can call it without threading React state around.
 * Closes on backdrop click, the ✕ button, or Escape.
 */
export function openMediaLightbox(url, type = 'image', caption = '') {
  if (!url) return;
  const existing = document.getElementById('gems-media-lightbox');
  if (existing) existing.remove();

  const overlay = document.createElement('div');
  overlay.id = 'gems-media-lightbox';
  overlay.style.cssText = [
    'position:fixed', 'inset:0', 'z-index:99999',
    'background:rgba(0,0,0,0.94)', 'display:flex', 'align-items:center',
    'justify-content:center', 'flex-direction:column', 'padding:24px',
  ].join(';');

  const isVideo = type === 'video' || /\.(mp4|webm|mov|m4v)(\?|$)/i.test(url);
  let media;
  if (isVideo) {
    media = document.createElement('video');
    media.src = url;
    media.controls = true;
    media.autoplay = true;
    media.loop = true;
    media.playsInline = true;
  } else {
    media = document.createElement('img');
    media.src = url;
    media.alt = 'Post media';
  }
  media.style.cssText = 'max-width:95vw;max-height:84vh;border-radius:12px;object-fit:contain;box-shadow:0 8px 40px rgba(0,0,0,0.8)';
  media.addEventListener('click', (e) => e.stopPropagation());

  const close = document.createElement('button');
  close.textContent = '✕';
  close.setAttribute('aria-label', 'Close');
  close.style.cssText = [
    'position:absolute', 'top:20px', 'right:24px', 'width:42px', 'height:42px',
    'border-radius:50%', 'border:none', 'background:rgba(255,255,255,0.14)',
    'color:#fff', 'font-size:18px', 'cursor:pointer',
  ].join(';');

  const doClose = () => {
    overlay.remove();
    document.removeEventListener('keydown', onKey);
  };
  const onKey = (e) => { if (e.key === 'Escape') doClose(); };

  overlay.addEventListener('click', doClose);
  close.addEventListener('click', doClose);
  document.addEventListener('keydown', onKey);

  overlay.appendChild(media);
  if (caption) {
    const cap = document.createElement('div');
    cap.textContent = caption;
    cap.style.cssText = 'color:#fff;font-size:14px;margin-top:14px;max-width:80vw;text-align:center;opacity:0.85';
    cap.addEventListener('click', (e) => e.stopPropagation());
    overlay.appendChild(cap);
  }
  overlay.appendChild(close);
  document.body.appendChild(overlay);
}

export default openMediaLightbox;
